export const paymentTrackIDs = {
    stepUp: 'dagligbank-lokalbank-step-up',
    actionButton: 'dagligbank-lokalbank-action-button',
    recurring: {
        paymentName: 'dagligbank-lokalbank-recurring-payment',
        transferName: 'dagligbank-lokalbank-recurring-transfer',
        agreement: 'dagligbank-lokalbank-recurring-agreement',
        update: 'dagligbank-lokalbank-recurring-update',
        delete: 'dagligbank-lokalbank-recurring-delete',
        bsu: 'dagligbank-lokalbank-recurring-bsu',
    },
    avtalegiro: {
        avtalegiroName: 'dagligbank-avtalegiro-details',
        agreement: 'dagligbank-lokalbank-avtalegiro-agreement',
        delete: 'dagligbank-lokalbank-avtalegiro-delete',
        update: 'dagligbank-lokalbank-avtalegiro-update',
        proposalName: 'dagligbank-avtalegiro-proposal-details',
        proposalAgreement: 'dagligbank-lokalbank-avtalegiro-proposal-agreement',
        proposalDelete: 'dagligbank-lokalbank-avtalegiro-proposal-delete',
        proposalUpdate: 'dagligbank-lokalbank-avtalegiro-proposal-update',
        moveAvtalegiros: 'dagligbank-lokalbank-avtalegiro-move',
        moveAvtalegiroError: 'dagligbank-lokalbank-avtalegiro-move-error',
        moveAvtalegiroErrorName: 'dagligbank-lokalbank-avtalegiro-move-try-again',
        createAvtalegiro: 'dagligbank-lokalbank-avtalegiro-create',
    },
    stopped: {
        paymentItem: 'dagligbank-lokalbank-stopped-payment',
        updateStoppedAvtalegiro: 'dagligbank-lokalbank-update-stopped-avtalegiro',
    },
};
